{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "最大サイズは {size} です。{imageLimit}、{typeLimitText}、{typeLimitZip}、または{typeLimitSpreadsheet}のみ添付できます。複数の書類をアップロードする場合は、先に zip にまとめてからアップロードしてください。",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "1 ファイルあたりの最大サイズは {size} です。最大 {count} ファイルまで。{image}、{text}、{zip}、または{spreadsheet}のみ添付できます。",
    "oneImage": "画像 1 枚",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "書類をアップロード",
    "uploadDocuments": "書類をアップロード"
  }
}
